import React, { useState } from 'react';
import { CompanyCard } from './CompanyTrendCard';
import Header from '../JobPage/Header';
import { CategoryTabs } from './CategoryTab';
import Footer from '../JobPage/Footer';
import { JobSeekerSection } from './JobSeekerSection';
import { useLocation } from 'react-router-dom';
import { Container } from '@/Components/ui/container';
import { Grid } from '@/Components/ui/layout';
import { Button } from '@/Components/ui/button';

export const BigTechHiring = () => {
  const [showAll, setShowAll] = useState(false);
  const companyData = new Array(8).fill(null);
  const visibleCompanies = showAll ? companyData : companyData.slice(0, 6);
  const location = useLocation();
  const { activeTab } = window.state || {};

  const toggleView = () => {
    setShowAll(!showAll);
  };

  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col items-center justify-center py-7 px-20">
      <Container size="default" className="w-full flex flex-col">
        <Header />
        <CategoryTabs activeTab={activeTab} />
        <Grid cols={3} gap="xl" className="mt-[167px]">
          {visibleCompanies.map((_, index) => (
            <CompanyCard key={index} />
          ))}
        </Grid>
        <Button 
          variant="default" 
          className="self-end mt-[73px] text-[35px] font-medium tracking-wide py-2.5 px-2.5"
          onClick={toggleView}
        >
          {showAll ? 'Show Less' : 'More'}
        </Button>
        <JobSeekerSection />
        <Footer />
      </Container>
    </div>
  );
};
